import { StateObject } from '../index';
import { createSelector } from '@reduxjs/toolkit';
import { AccountObject, UserData, UserState } from 'store/slices/user/userSlice';

export const getJWTToken = (state: StateObject) => state.user.userData.jwtToken;

export const getUser = ({ user }: StateObject) => user;

export const getUserData = createSelector(
  getUser,
  ({ userData }: UserState) => userData
);
export const getUserAccounts = createSelector(
  getUserData,
  ({ userAccounts }: UserData) => userAccounts
);

export const getFirstAccount = createSelector(
  getUserAccounts,
  (accounts: AccountObject[]): AccountObject => {
    return accounts && accounts.length > 0 ? accounts[0] : {} as AccountObject
  }
);

export const getUserRole = createSelector(
  getFirstAccount,
  ({ userType }: AccountObject) => userType
);

export const getPatientId = createSelector(getFirstAccount, ({ patientId }) => patientId);

export const getUserAccountId = createSelector(getFirstAccount, ({ userAccountId }) => userAccountId);

export const getSubscriptionStatus = createSelector(getUserData, ({ subscriptionStatus }) => subscriptionStatus);

export const getClientId = createSelector(getFirstAccount, ({ clientId }) => clientId);